import { PHYSICS } from '@ponponland/shared';

/**
 * One source of truth for the on-screen WORLD scale so the in-game stage renders
 * at the EXACT same character:tile ratio as the plaza (Pon Pon Plaza / LobbyScene).
 *
 * The plaza renders its local Pon at `PLAZA_PON_SIZE` px on screen at a 1:1 world
 * scale (no camera zoom). The stage is a server-authoritative sim measured in
 * gameplay TILES (`PHYSICS.bodyDiameter` 1.5 tiles per Pon). To make the stage
 * Pon read at the plaza's `PLAZA_PON_SIZE` while the terrain ART tile reads at the
 * plaza's tile size, the stage renders every gameplay tile at `STAGE_RENDER_PX`
 * px (so a 1.5-tile Pon body = `PLAZA_PON_SIZE`), with NO camera zoom, while the
 * terrain art (`tileTerrain.ts`) keeps drawing its texture at the plaza's display
 * tile size. This is a CLIENT RENDER scale only — the shared `TILE_SIZE`,
 * `PHYSICS.bodyDiameter`, level grid/collision and server positions are untouched.
 */

/** The plaza's on-screen Pon diameter (px) — `LobbyScene.PLAZA_PON_SIZE`. */
export const PLAZA_PON_SIZE = 52;

/**
 * Stage render pixels per gameplay tile. Chosen so a Pon body
 * (`PHYSICS.bodyDiameter` tiles) renders at exactly `PLAZA_PON_SIZE` px on screen,
 * matching the plaza Pon. ≈ 34.667 px/tile (52 / 1.5).
 */
export const STAGE_RENDER_PX = PLAZA_PON_SIZE / PHYSICS.bodyDiameter;
